import React from 'react'

function PatientListStep({ formData, setFormData, searchTerm, setSearchTerm, searchFilter, setSearchFilter, showDatePicker, setShowDatePicker, selectedDate, setSelectedDate, showGenderFilter, setShowGenderFilter, selectedGender, setSelectedGender, showAgeFilter, setShowAgeFilter, minAge, setMinAge, maxAge, setMaxAge, searchOptions = ['firstName', 'lastName', 'email'] }) {
    return (
        <div className="animate-fade-in">
            <h3 className="fw-bold text-gray-900 mb-2">Patient List</h3>
            <p className="text-muted mb-8">Select patients who will receive this message.</p>
            
            <div className="row">
                {/* Left Side - Quick Add and Search (40%) */}
                <div className="col-5">
                    {/* Search with Filters */}
                    <div className="mb-4">
                        <div className="input-group input-group-sm mb-2">
                            <select 
                                className="form-select form-select-sm" 
                                style={{ maxWidth: '120px' }}
                                value={searchFilter}
                                onChange={(e) => setSearchFilter(e.target.value)}
                            >
                                {searchOptions.includes('firstName') && <option value="firstName">First Name</option>}
                                {searchOptions.includes('lastName') && <option value="lastName">Last Name</option>}
                                {searchOptions.includes('email') && <option value="email">Email</option>}
                                {searchOptions.includes('phone') && <option value="phone">Phone</option>}
                            </select>
                            <input 
                                type="text" 
                                className="form-control" 
                                placeholder="Search patients..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <button className="btn btn-primary">
                                Search
                            </button>
                        </div>
                    </div>

                    {/* Quick Add Options */}
                    <div>
                        <label className="form-label fw-semibold mb-2">Quick Add Options</label>
                        <div className="row g-2">
                            <div className="col-12">
                                <button className="btn btn-light-primary w-100 text-start py-2">
                                    <div className="d-flex align-items-center">
                                        <span className="svg-icon svg-icon-2hx svg-icon-primary me-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"></rect>
                                                <path d="M16 2V6" stroke="currentColor" strokeWidth="2"></path>
                                                <path d="M8 2V6" stroke="currentColor" strokeWidth="2"></path>
                                                <path d="M3 10H21" stroke="currentColor" strokeWidth="2"></path>
                                            </svg>
                                        </span>
                                        <span className="fw-bold fs-6">Today's Appointments</span>
                                    </div>
                                </button>
                            </div>
                            <div className="col-12">
                                <button className="btn btn-light-info w-100 text-start py-2">
                                    <div className="d-flex align-items-center">
                                        <span className="svg-icon svg-icon-2hx svg-icon-info me-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"></rect>
                                                <path d="M16 2V6" stroke="currentColor" strokeWidth="2"></path>
                                                <path d="M8 2V6" stroke="currentColor" strokeWidth="2"></path>
                                                <path d="M3 10H21" stroke="currentColor" strokeWidth="2"></path>
                                            </svg>
                                        </span>
                                        <span className="fw-bold fs-6">Tomorrow's Appointments</span>
                                    </div>
                                </button>
                            </div>
                            <div className="col-12">
                                <button className="btn btn-light-warning w-100 text-start py-2">
                                    <div className="d-flex align-items-center">
                                        <span className="svg-icon svg-icon-2hx svg-icon-warning me-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"></rect>
                                                <path d="M16 2V6" stroke="currentColor" strokeWidth="2"></path>
                                                <path d="M8 2V6" stroke="currentColor" strokeWidth="2"></path>
                                                <path d="M3 10H21" stroke="currentColor" strokeWidth="2"></path>
                                            </svg>
                                        </span>
                                        <span className="fw-bold fs-6">Yesterday's Appointments</span>
                                    </div>
                                </button>
                            </div>
                            <div className="col-12">
                                <button 
                                    className="btn btn-light-success w-100 text-start py-2"
                                    onClick={() => setShowDatePicker(!showDatePicker)}
                                >
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <span className="svg-icon svg-icon-2hx svg-icon-success me-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"></rect>
                                                    <path d="M16 2V6" stroke="currentColor" strokeWidth="2"></path>
                                                    <path d="M8 2V6" stroke="currentColor" strokeWidth="2"></path>
                                                    <path d="M3 10H21" stroke="currentColor" strokeWidth="2"></path>
                                                </svg>
                                            </span>
                                            <span className="fw-bold fs-6">Specific Date</span>
                                        </div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                        </svg>
                                    </div>
                                </button>
                                {showDatePicker && (
                                    <div className="mt-2 p-3 bg-white border rounded-3">
                                        <input 
                                            type="date" 
                                            className="form-control form-control-sm"
                                            value={selectedDate}
                                            onChange={(e) => setSelectedDate(e.target.value)}
                                        />
                                        <button 
                                            className="btn btn-primary btn-sm w-100 mt-2"
                                            onClick={() => {
                                                if (selectedDate) {
                                                    console.log('Adding patients for date:', selectedDate)
                                                }
                                                setShowDatePicker(false)
                                            }}
                                        >
                                            Add Patients
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className="col-12">
                                <button 
                                    className="btn btn-light-danger w-100 text-start py-2"
                                    onClick={() => setShowGenderFilter(!showGenderFilter)}
                                >
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <span className="svg-icon svg-icon-2hx svg-icon-danger me-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2"></path>
                                                    <path d="M9 10L12 13L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                                </svg>
                                            </span>
                                            <span className="fw-bold fs-6">By Gender</span>
                                        </div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                        </svg>
                                    </div>
                                </button>
                                {showGenderFilter && (
                                    <div className="mt-2 p-3 bg-white border rounded-3">
                                        <div className="d-flex flex-column gap-2">
                                            <label className="form-check">
                                                <input 
                                                    type="radio" 
                                                    className="form-check-input"
                                                    name="gender"
                                                    value="Male"
                                                    checked={selectedGender === 'Male'}
                                                    onChange={(e) => setSelectedGender(e.target.value)}
                                                />
                                                <span className="form-check-label">Male</span>
                                            </label>
                                            <label className="form-check">
                                                <input 
                                                    type="radio" 
                                                    className="form-check-input"
                                                    name="gender"
                                                    value="Female"
                                                    checked={selectedGender === 'Female'}
                                                    onChange={(e) => setSelectedGender(e.target.value)}
                                                />
                                                <span className="form-check-label">Female</span>
                                            </label>
                                            <label className="form-check">
                                                <input 
                                                    type="radio" 
                                                    className="form-check-input"
                                                    name="gender"
                                                    value="Other"
                                                    checked={selectedGender === 'Other'}
                                                    onChange={(e) => setSelectedGender(e.target.value)}
                                                />
                                                <span className="form-check-label">Other</span>
                                            </label>
                                            <button 
                                                className="btn btn-primary btn-sm w-100 mt-2"
                                                onClick={() => {
                                                    if (selectedGender) {
                                                        console.log('Adding patients for gender:', selectedGender)
                                                    }
                                                    setShowGenderFilter(false)
                                                }}
                                            >
                                                Add Patients
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="col-12">
                                <button 
                                    className="btn btn-light-secondary w-100 text-start py-2"
                                    onClick={() => setShowAgeFilter(!showAgeFilter)}
                                >
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <span className="svg-icon svg-icon-2hx svg-icon-secondary me-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2"></path>
                                                    <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                                </svg>
                                            </span>
                                            <span className="fw-bold fs-6">By Age</span>
                                        </div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                        </svg>
                                    </div>
                                </button>
                                {showAgeFilter && (
                                    <div className="mt-2 p-3 bg-white border rounded-3">
                                        <div className="row g-2">
                                            <div className="col-6">
                                                <label className="form-label small">Min Age</label>
                                                <input 
                                                    type="number" 
                                                    className="form-control form-control-sm"
                                                    placeholder="Min"
                                                    value={minAge}
                                                    onChange={(e) => setMinAge(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-6">
                                                <label className="form-label small">Max Age</label>
                                                <input 
                                                    type="number" 
                                                    className="form-control form-control-sm"
                                                    placeholder="Max"
                                                    value={maxAge}
                                                    onChange={(e) => setMaxAge(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <button 
                                            className="btn btn-primary btn-sm w-100 mt-2"
                                            onClick={() => {
                                                if (minAge && maxAge) {
                                                    console.log('Adding patients for age range:', minAge, '-', maxAge)
                                                }
                                                setShowAgeFilter(false)
                                            }}
                                        >
                                            Add Patients
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Side - Selected Patients (60%) */}
                <div className="col-7">
                    <div className="card border-0 bg-light h-100">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h5 className="fw-bold mb-0">Selected Patients</h5>
                                <span className="badge bg-primary fs-7">{formData.selectedPatients.length} selected</span>
                            </div>
                            {formData.selectedPatients.length === 0 ? (
                                <div className="text-center py-8 text-muted">
                                    <p>No patients selected yet</p>
                                </div>
                            ) : (
                                <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                {searchOptions.includes('email') && <th>Email</th>}
                                                {searchOptions.includes('phone') && <th>Phone</th>}
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {formData.selectedPatients.map((patient, index) => (
                                                <tr key={index}>
                                                    <td>{patient.name}</td>
                                                    {searchOptions.includes('email') && <td>{patient.email}</td>}
                                                    {searchOptions.includes('phone') && <td>{patient.phone}</td>}
                                                    <td>
                                                        <button 
                                                            className="btn btn-sm btn-light-danger"
                                                            onClick={() => {
                                                                const newPatients = [...formData.selectedPatients]
                                                                newPatients.splice(index, 1)
                                                                setFormData({...formData, selectedPatients: newPatients})
                                                            }}
                                                        >
                                                            Remove
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PatientListStep
